module.exports = __webpack_public_path__ + "img/iconoubi.85f95ce8.svg";